import { useCallback, useRef } from 'react';
import devDebug from "../Helpers/debug";

export default function debounce(func, timeout = 700) {
    devDebug("debounce with timeout: ", timeout);
    let timer;
    return (...args) => {
        devDebug("submitting, with args: ", ...args);
        clearTimeout(timer);
        timer = setTimeout(() => {
            devDebug("executing, with args: ", ...args);
            func.apply(this, args);
        }, timeout);
    };
}


export function useDebounce(callback, delay) {
    const timeoutRef = useRef();

    return useCallback((...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);
}

export function useImmediateDebounce(callback, delay = 500, immediateWindow = 1000) {
    const timeoutRef = useRef();
    const lastCallTime = useRef(0);

    return useCallback((...args) => {
        const now = Date.now();
        const timeSinceLastCall = now - lastCallTime.current;

        // Clear any existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // If it's the first call or we're outside the immediate window,
        // execute immediately
        if (lastCallTime.current === 0 || timeSinceLastCall > immediateWindow) {
            lastCallTime.current = now;
            callback(...args);
            return;
        }

        // Otherwise, debounce the call
        timeoutRef.current = setTimeout(() => {
            lastCallTime.current = now;
            callback(...args);
        }, delay);
    }, [callback, delay, immediateWindow]);
}